import api from 'api'

export type IndeedFlexAuthStatusResponse = {
  sessionReady: boolean
  errorMessage: string | null
}

export const getIndeedFlexAuthStatus =
  async (): Promise<IndeedFlexAuthStatusResponse> => {
    const result = await api.get<IndeedFlexAuthStatusResponse>(
      '/admin/indeed_flex/auth_status'
    )
    return result.data
  }
